module.exports = __webpack_public_path__ + "img/card-icon.e2f414a2.png";